import 'alpinejs';
import Echo from 'laravel-echo';
import Mousetrap from 'mousetrap';

window.$ = document.querySelector.bind(document);
window.$$ = document.querySelectorAll.bind(document);

window._ = require('lodash');

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    forceTLS: true
});

// TODO: figure out a way to bind to just submittable forms - https://craig.is/killing/mice
// var forms = document.querySelectorAll('form');
// Mousetrap(forms).bind('mod+s', function(e, combo) {
//     e..stopPropagation();
//     e.preventDefault();
//     e.submit();
// });
